var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home1"}},[_c('navbar'),_c('hero-section9'),_c('services'),_c('start-process'),_c('about'),_c('partner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }